import { Component, Input, OnInit } from '@angular/core';
import {ModalController} from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonLabel, IonInput } from "@ionic/angular/standalone";
import { DisplayService } from '@qid/core';
import { Industry } from '../../model/industry.model';
import { CreateIndustryDto } from '../../dto/create-industry.dto';
import { IndustryService } from '../../services/industry.service';
import {RestResponse} from "../../../../../interface/RestInterface";
import { FormsModule } from '@angular/forms';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, PageActionComponent } from '@qid/super';

@Component({
  selector: 'app-create-industry',
  templateUrl: './create-industry.page.html',
  styleUrls: ['./create-industry.page.scss'],
  standalone: true,
  imports: [
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    PageActionComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonInput
  ]
})
export class CreateIndustryPage implements OnInit {

  public industry: Industry;

  @Input() parentIndustry: Industry = null;

  public dto: CreateIndustryDto = new CreateIndustryDto();
  public id:any = null;

  constructor(private industryService: IndustryService,
              private modalController: ModalController,
              private displayService: DisplayService
              ) {
  }

  ngOnInit() {
  }

  create = async () => {
    let res:RestResponse<Industry>
    this.dto.parentIndustry = this.parentIndustry?._id;
      res = await this.industryService.create(this.dto);
    if (res.data) {
      await this.displayService.toast({message: 'Industry created successfully',position:'top'});
      await this.modalController.dismiss();
    }
  }
}
